import { createContext, useContext } from "react";
import { useToast } from "@chakra-ui/react";

const ToastContext = createContext(null);

export const ToastProvider = ({ children }) => {
    const toast = useToast();

    const showToast = ({ title, description, status = "info", duration = 5000 }) => {
        toast({
            title,
            description,
            status,
            duration,
            isClosable: true,
            position: "top-right",
        });
    };

    return (
        <ToastContext.Provider value={showToast}>
            {children}
        </ToastContext.Provider>
    );
};

export const useCustomToast = () => {
    return useContext(ToastContext);
};
